import styled, { createGlobalStyle } from "styled-components";
import React from "react";
import Game from "./components/Game";

const App: React.FC = () => {
  return (
    <Container>
      <GlobalStyle />
      <Compass aria-hidden="true">
        <svg viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="50" cy="50" r="38" fill="none" stroke="currentColor" strokeWidth="0.75" />
          <path d="M50 6 L56 50 L50 94 L44 50 Z" fill="currentColor" />
          <path d="M6 50 L50 44 L94 50 L50 56 Z" fill="currentColor" opacity="0.6" />
        </svg>
      </Compass>

      <Header>
        <span className="pin">📍</span>
        <h1>Decode Journey</h1>
      </Header>
      <Tagline>Explore le monde, une lettre à la fois</Tagline>

      <Game />
    </Container>
  );
};

const GlobalStyle = createGlobalStyle`
  *, body {
    margin: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
  }
`;

const Compass = styled.div`
  position: fixed;
  bottom: -60px;
  right: -60px;
  width: 340px;
  height: 340px;
  color: #ffffff;
  opacity: 0.06;
  animation: spin 60s linear infinite;
  pointer-events: none;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  > .pin {
    font-size: 1.6rem;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.3));
  }

  > h1 {
    font-family: "Playfair Display", serif;
    font-weight: 700;
    font-style: normal;
    letter-spacing: 0.5px;
    background: linear-gradient(90deg, #f3d16f, #d9a234);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

const Tagline = styled.p`
  color: #cfe3ec;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin-top: 4px;
  padding-bottom: 24px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: #0b2733;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 24px 0;
  position: relative;
  overflow: hidden;

  background:
    radial-gradient(circle at 15% 20%, rgba(255, 255, 255, 0.05) 0, transparent 40%),
    radial-gradient(circle at 85% 75%, rgba(255, 255, 255, 0.04) 0, transparent 45%),
    linear-gradient(-45deg, #04202e, #0b3d55, #157a9e, #0b3d55);
  background-size: 180% 180%, 180% 180%, 300% 300%;
  animation: drift 18s ease infinite;

  @keyframes drift {
    0% {
      background-position: 0% 50%, 0% 50%, 0% 50%;
    }
    50% {
      background-position: 100% 50%, 100% 50%, 100% 50%;
    }
    100% {
      background-position: 0% 50%, 0% 50%, 0% 50%;
    }
  }
`;

export default App;
